import './module/common';
import './module/slick';
import './module/menu';
//import './module/parallax';
//import './module/inview';
//import './module/matchheight';
import './module/script';
//import './module/shuffle';
//import './module/topmovie';
//import './module/lower';
import './module/aos';
//import './module/form';


